import {api} from '@/store/resources'
import notificationsSettings from "@/store/app/user/notificationsSettings";

export default {
    namespaced: true,
    state: {
        user_info: {
            data: {},
            dirty: true,
        }
    },
    getters: {
        userLang: (state) => state.user_info.data.language,
        hasSpace: (state) => !!state.user_info.data.space_id,
        showWizard: (state) => state.user_info.data.settings.show_intro,
        displayedName: (state) => state.user_info.data.name || state.user_info.data.username || state.user_info.data.email,
    },
    actions: {
        async getUserInfo({commit, dispatch}, id) {
            try {
                const res = await api.users_params.get({id});
                commit('setUserInfo', res.body.data.user);
                if (res.body.data.language !== null) {
                    dispatch('i18n/changeLang', res.body.data.user.language, {root: true});
                }
            } catch (err) {
                console.error(err)
            }
        },
        updateUser({}, data) {
            return api.users_params.update({id: data.id}, {...data});
        },
        updateUserSettings({}, data) {
            return api.user_settings.update({id: data.id}, {...data});
        },
        async setUserPrimarySpaceId({commit, state}, space_id) {
            const res = await api.users_params.update({id: state.user_info.data.id}, {space_id})
            commit('setUserPrimarySpaceId', res.body.data.user.space_id);
            // if (router.currentRoute.name === "create-accounting") {
            //     //navigate to dashboard if user is loaded w deleted space
            //     router.push({name: 'home'})
            // }
        },
        sendConfirmEmail({state}) {
            return api.send_confirm_email.get({id: state.user_info.data.id});
        },
        getUserSessions() {
            return api.sessions.get();
        },
        updateSession({}, data) {
            const {id, name} = data;
            return api.sessions.update({id}, {name});
        },
        deleteSession({}, id) {
            return api.sessions.delete({id});
        },
        setNewSettingsPIN() {
            return api.reset_pin.save();
        },
        disableWizard({state, commit}) {
            api.user_settings.update({id: state.user_info.data.id}, {show_intro: false})
                .then(res => {
                    if (res.body.success) {
                        commit('setUserSettings', (res.body.data))
                    } else {
                        console.log(res);
                    }
                }).catch(e => {
                console.log(e)
            })
        },
        connectSocialAccount({}, provider) {
            return api.connect_social_acc.save({provider})
        },
        async disconnectSocialAccount({state, dispatch}, provider) {
            try {
                const res = await api.disconnect_social_acc.save({provider})
                if (res.body.success) {
                    dispatch('getUserInfo', state.user_info.data.id)
                }
            } catch (err) {
                console.error(err)
            }
        },
    },
    mutations: {
        setUserInfo(state, data) {
            state.user_info.data = data;
            state.user_info.dirty = false;
        },
        setUserSettings(state, data) {
            state.user_info.data.settings = data;
        },
        setUserPrimarySpaceId(state, id) {
            state.user_info.data.space_id = id;
        },
        setUserUsesPIN(state) {
            state.user_info.data.pin_enabled = 1;
        },
        clearUserInfo(state) {
            state.user_info.data = {};
            state.user_info.dirty = true;
        }
    },
    modules: {
        notificationsSettings
    }
}
